import router from '../router/router'
import {getUrlParams } from '@/js/tooljs/utils.js'
export default {
    data() {
        return {
            pageConfigName:"",
        }
    },
    methods: {

    }
}